import { makeStyles, Theme, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      background: `linear-gradient(rgb(216, 216, 216), rgb(255, 255, 255))`
    },
    header: {},
    contentWrapper: {
      marginTop: theme.spacing(-11.25),
      minHeight: "100vh"
    },
    buttonWrapper: {
      flex: "0 0 17%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      height: "100px",
      alignItems: "center",
      "@media (min-width: 960px)": {
        margin: "3vh 8vw"
      }
    },
    smsButtonOff: {
      color: theme.palette.primary.main,
      textTransform: "none",
      padding: theme.spacing(0),
      fontSize: theme.typography.h6.fontSize,
      marginTop: theme.spacing(4.5),
      lineHeight: "1",
      "& .MuiButton-label": {
        display: "flex",
        justifyContent: "center"
      }
    },
    smsButtonOn: {
      width: theme.spacing(50),
      height: theme.spacing(12),
      fontSize: theme.typography.h6.fontSize,

      textTransform: "none",
      fontFamily: theme.typography.h3.fontFamily,
      boxShadow: theme.shadows[4],
      margin: theme.spacing(0, "auto"),
      padding: theme.spacing(0),
      "&.Mui-disabled": {
        color: theme.palette.primary.contrastText
      }
    },
    wrapper: {
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      background: `linear-gradient(rgb(216, 216, 216), rgb(255, 255, 255))`,
      marginBottom: theme.spacing(-5),
      marginTop: theme.spacing(-13)
    },
    content: {
      display: "flex",
      height: "100vh",
      background: `linear-gradient(rgb(216, 216, 216), rgb(255, 255, 255))`,
      justifyContent: "center",
      minHeight: "100vh",
      flexDirection: "column"
    },
    imageWrapper: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      flex: "2 1 50%"
    },
    textWrapper: {
      display: "flex",
      fontSize: "16px",
      alignItems: "flex-start",
      flexDirection: "column",
      color: theme.palette.secondary.light,
      margin: "0vh 5vw",
      flex: "1 0 auto"
    },
    heading: {
      margin: theme.spacing(1, 0, 1.5),
      fontFamily: theme.typography.h3.fontFamily
    },
    descriptionText: {
      marginTop: theme.spacing(0),
      fontSize: theme.typography.h6.fontSize,
      lineHeight: "22px"
    },

    smsHeroImage: {
      maxWidth: "90%",
      margin: "5% 0 0 5%"
    },
    notification: {
      maxWidth: "90%",
      position: "absolute",
      margin: "50% 0 0 5%",
      transform: "translate3d(0,-50px,0)",
      webkitTransform: "translate3d(0,-50px,0)",
      animation: "$easing_in 600ms linear 0s 1"
    },

    "@keyframes easing_in": {
      "0%": {
        opacity: 0,
        transform: "translate3d(0,0,0)",
        webkitTransform: "translate3d(0,0,0)"
      },
      "30%": {
        opacity: 0,
        transform: "translate3d(0,-10px,0)",
        webkitTransform: "translate3d(0,-10px,0)"
      },
      "65%": {
        opacity: 0,
        transform: "translate3d(0,-25px,0)",
        webkitTransform: "translate3d(0,-25px,0)"
      },
      "100%": {
        opacity: 1,
        transform: "translate3d(0,-50px,0)",
        webkitTransform: "translate3d(0,-50px,0)"
      }
    }
  })
);
